import React, {useState, useEffect, useContext} from "react"

// data & context
import Cart from "./../data/cart"
import {CatalogueContext} from "./CatalogueContext"

// context
const ShopContext = React.createContext()

// the provider
const ShopProvider = (props) => {
  // the catalogue context
  const catalogue = useContext(CatalogueContext)

  // cart
  const [cartActivities, setCartActivities] = useState([])
  const [cartSignature, setCartSignature] = useState(Date.now()) // used to track changes to the cart (activities, promocode, shipping type)
  const [cartValidation, setCartValidation] = useState(Cart.getDefaultValidation())
  
  // initialization (as soon as catalogue is ready)
  useEffect(() => {
    // the cart
    if(catalogue.isReady) {
      setCartActivities(Cart.getActivities())
      setCartValidation(Cart.getValidation())
      setCartSignature(Date.now())
    }
  }, [catalogue.isReady]) 
  
  // the provided value
  let value = {
    // TODO consider moving this inside cart: {}
    cartActivities,
    cartSignature,
    cartValidation,

    // functions (cart)
    cart: {
      addActivity: (activity, regionCode, options, participantCount, subactivities) => {
        Cart.addActivity(activity, regionCode, options, participantCount, subactivities)
        setCartActivities(Cart.getActivities())
        setCartValidation({...Cart.getValidation()})
        setCartSignature(Date.now())
      },
      removeActivity: (activityId) => {
        Cart.removeActivity(activityId)
        setCartActivities(Cart.getActivities())
        setCartValidation({...Cart.getValidation()})
        setCartSignature(Date.now())
      },
      removeAllActivities: () => {
        Cart.removeAllActivities();
        setCartActivities(Cart.getActivities())
        setCartValidation({...Cart.getValidation()})
        setCartSignature(Date.now())
      },
      removeActivityPackage: (activityPackage) => {
        Cart.removeActivityPackage(activityPackage);
        setCartActivities(Cart.getActivities())
        setCartValidation({...Cart.getValidation()})
        setCartSignature(Date.now())
      },
      setShippingType: (shippingType) => {
        Cart.setShippingType(shippingType) // TODO using cart signature should be enough
        setCartSignature(Date.now())
      },
      setVoucher: (voucher) => {
        Cart.setVoucher(voucher)
        setCartValidation({...Cart.getValidation()})
        setCartSignature(Date.now())
      },
      setValidation: (validation) => {
        setCartValidation(validation)
      },
      submit: async(token) => {
        let response = await Cart.submit(token)
        if(response.ok) {
          // empty cart
          setCartActivities([])
        }
        // update signature to force view to update
        setCartSignature(Date.now())
        return response
      },
      initializePayrexx: async() => {
        // initialize the payment process, the reponse contains ok, id, and payrexxGateway with payrexxGateway.link
        let response = await Cart.initializePayrexx();
        // update signature to force view to update
        setCartSignature(Date.now());
        // return the response 
        return response;
      },
      finalizePayrexx: async() => {
        let response = await Cart.finalizePayrexx();
        // empty cart
        setCartActivities([])
        // update signature to force view to update
        setCartSignature(Date.now());
        // return the response
        return response;
      },
      count: () => {
        return Cart.count2();
      }
    }
  }

  return (
    <ShopContext.Provider value={value}>
      {props.children}
    </ShopContext.Provider>
  )
}


export {ShopContext, ShopProvider}


// TODO since we alredy have all the data in the context provider's state, is it really necessary to also store tin the data/catalogue, data/region, data/properties containers? ... all the data points at the same reference (I think), but still ...